const _require = require('lodash'),
  isPlainObject = _require.isPlainObject;
const _require2 = require('@truqc/content-path'),
  getFlattenedContentValues = _require2.getFlattenedContentValues;
const _require3 = require('../lib/evaluateSource'),
  evaluateSource = _require3.evaluateSource;

/**
  * @function evalute - evaluate getObjectValuesBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (!isPlainObject(object)) {
    return undefined;
  }
  const paths = await evaluateSource(source.paths, content, parentContentPath, transientContext, nativeFunctions);
  if (!Array.isArray(paths)) {
    return undefined;
  }
  const requireAllValues = await evaluateSource(source.requireAllValues, content, parentContentPath, transientContext, nativeFunctions);
  return getFlattenedContentValues(paths, object, requireAllValues);
};
module.exports = {
  evaluate
};